import {
  CdkDragDrop,
  DragDropModule,
  moveItemInArray,
  transferArrayItem,
} from '@angular/cdk/drag-drop';
import {
  Component,
  input,
  OnInit,
  output,
  signal,
  WritableSignal,
} from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { GroupColumnItemComponent } from 'demand-forecasting/analysis/components/configuration/steps/hierarchy-step-analysis-configuration/drag-and-drop-hierarchy/group-column-item.component';

@Component({
  selector: 'pm-drag-and-drop-hierarchy',
  templateUrl: './drag-and-drop-hierarchy.component.html',
  imports: [
    ReactiveFormsModule,
    DragDropModule,
    GroupColumnItemComponent,
    TranslateModule,
  ],
  host: {
    class: 'block h-full w-full',
  },
})
export class DragAndDropHierarchyComponent implements OnInit {
  initUnassignedGroupColumns = input.required<string[]>();
  initHierarchy = input.required<string[]>();

  handleHierarchyChange = output<string[]>();

  unassignedGroupColumns: WritableSignal<string[]> = signal<string[]>([]);
  hierarchy: WritableSignal<string[]> = signal<string[]>([]);

  ngOnInit(): void {
    const unassignedGroupColumns = this.initUnassignedGroupColumns();
    const initHierarchy = this.initHierarchy();

    // remove items from unassignedGroupColumns that are already in hierarchy
    const filteredUnassignedGroupColumns = unassignedGroupColumns.filter(
      (item) => !initHierarchy.includes(item),
    );

    this.unassignedGroupColumns.set(filteredUnassignedGroupColumns);
    this.hierarchy.set(initHierarchy);
  }

  onDrop(event: CdkDragDrop<string[]>) {
    const unassignedGroupColumns = [...this.unassignedGroupColumns()];
    const hierarchy = [...this.hierarchy()];

    if (event.previousContainer.id === event.container.id) {
      moveItemInArray(
        event.container.id === 'unassignedGroupColumns'
          ? unassignedGroupColumns
          : hierarchy,
        event.previousIndex,
        event.currentIndex,
      );
    } else {
      transferArrayItem(
        event.previousContainer.id === 'hierarchy'
          ? hierarchy
          : unassignedGroupColumns,
        event.previousContainer.id === 'hierarchy'
          ? unassignedGroupColumns
          : hierarchy,
        event.previousIndex,
        event.currentIndex,
      );
    }

    this.unassignedGroupColumns.set(unassignedGroupColumns);
    this.hierarchy.set(hierarchy);
    this.handleHierarchyChange.emit(hierarchy);
  }
}
